'use client';

import { useGetSiteConfigs } from '@/hooks/query/use-site-configs'
import { siteService } from '@/services/site.service';

interface CdnImgProps extends React.ComponentPropsWithoutRef<'img'> {
    src: string;
    isGalaxyFolder?: boolean;
}

export const CdnImg = (props: CdnImgProps) => {
	const { SiteConfigsData: siteConfigsData, isLoading, isError } = useGetSiteConfigs();
	const { isGalaxyFolder, ...imgProps } = props;
	if (isLoading || isError) return <></>;
	return isGalaxyFolder !== undefined && siteConfigsData?.EnableImageServer && siteConfigsData.ImageServerUrl ? (
		<img {...imgProps} src={siteService.combineImagePath(imgProps.src, isGalaxyFolder, siteConfigsData)} />
	) : (
		<img {...imgProps} src={`${imgProps.src}?v=${process.env.NEXT_PUBLIC_FILE_VERSION_ID}`} />
	)
}
